import React from "react";
import {
  AiOutlineGithub,
  AiOutlineFacebook,
  AiOutlineLinkedin,
  AiOutlineYoutube,
} from "react-icons/ai";

const Header = ({ data }) => {
  const { btntext, subtitle, img, title } = data;
  return (
    <div className="h-auto w-auto relative flex flex-col">
      <div className=" bg-theme clip-path w-auto h-[85vh] lg:h-[75vh] md:h-[65vh] sm:h-[55vh] absolute top-0 right-0 left-0 opacity-95 z-10  "></div>
      <div className="relative opacity-100 grid items-center justify-items-center nike-container z-50">
        <div className="grid items-center justify-items-center pt-10">
          <h1 className="grid items-center justify-items-center filter drop-shadow-sm text-6xl lg:text-5xl md:text-4xl sm:3xl xsm:text-2xl text-slate-200 font-bold ">
            {title}
          </h1>
          <h1 className="grid items-center justify-items-center filter drop-shadow-sm text-6xl lg:text-5xl md:text-4xl sm:3xl xsm:text-2xl text-slate-200 font-bold ">
            {subtitle}
          </h1>
          <button className="button-theme rounded-lg shadow-slate-200 my-5 bg-slate-200">
            {btntext}
          </button>
          <div className="gap-2 grid items-center text-4xl absolute right-0 top-[33vh] lg:[27vh] text-slate-200 ">
            <a
              href="https://www.github.com/ehtesham25"
              target={"_blank"}
              rel="noreferrer"
            >
              <AiOutlineGithub className=" cursor-pointer  hover:scale-125 ease-in duration-200" />
            </a>
            <a
              href="https://www.linkedin.com/in/ehtisham-ul-haq-b92872161/"
              target={"_blank"}
              rel="noreferrer"
            >
              <AiOutlineLinkedin className=" cursor-pointer  hover:scale-125 ease-in duration-200" />
            </a>
            <a
              href="https://ehtisham-mern-dev.netlify.app/"
              target={"_blank"}
              rel="noreferrer"
            >
              <AiOutlineYoutube className=" cursor-pointer  hover:scale-125 ease-in duration-200" />
            </a>
            <a
              href="https://web.facebook.com/ehtesham.ulhaq.503/"
              target={"_blank"}
              rel="noreferrer"
            >
              <AiOutlineFacebook className=" cursor-pointer  hover:scale-125 ease-in duration-200" />
            </a>
          </div>
        </div>
        <div>
          <img
            src={img}
            alt="header"
            className="w-auto h-[45vh] lg:h-[35] md:h-[31vh] sm:h-[23vh] xsm:h-[19vh] object-fill drop-shadow-xl transitions-theme -rotate-[30deg] hover:rotate-0 "
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
